import './index.scss';

export default function Footer({ isSidebarOpen = false }) {
  return (
    <footer className={'layout-footer' + (isSidebarOpen ? ' sidebar' : '')}>
      ©2022. Fridays Lab Inc. all rights reserved.
    </footer>
  );
}
